export const disabledWrapperStyles = {
  pointerEvents: 'none',
  opacity: 0.5,
  userSelect: 'none',
};
